export default __webpack_public_path__ + "static/media/settings.4a3025bb.svg";